export const CoreInitiativesCommentsByIdName = 'CoreInitiativesCommentsById';
